import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Analytics = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fill={color}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 2.35001C10.5 2.07386 10.7239 1.85001 11 1.85001H14C14.2761 1.85001 14.5 2.07386 14.5 2.35001V5.35001C14.5 5.62615 14.2761 5.85001 14 5.85001C13.7239 5.85001 13.5 5.62615 13.5 5.35001V3.64604L8.31663 7.88698C8.11781 8.04965 7.82809 8.0352 7.64645 7.85356L5.97722 6.18433L2.32926 9.37629C2.12144 9.55814 1.80556 9.53708 1.62372 9.32926C1.44188 9.12144 1.46294 8.80556 1.67075 8.62372L5.67075 5.12372C5.86886 4.95038 6.16743 4.96032 6.35356 5.14645L8.0336 6.82649L12.8937 2.85001H11C10.7239 2.85001 10.5 2.62615 10.5 2.35001ZM3.5 10.5C3.77614 10.5 4 10.7239 4 11L4 13.5C4 13.7761 3.77614 14 3.5 14C3.22386 14 3 13.7761 3 13.5V11C3 10.7239 3.22386 10.5 3.5 10.5ZM6.5 8C6.77614 8 7 8.22386 7 8.5V13.5C7 13.7761 6.77614 14 6.5 14C6.22386 14 6 13.7761 6 13.5V8.5C6 8.22386 6.22386 8 6.5 8ZM10 9.5C10 9.22386 9.77614 9 9.5 9C9.22386 9 9 9.22386 9 9.5V13.5C9 13.7761 9.22386 14 9.5 14C9.77614 14 10 13.7761 10 13.5V9.5ZM12.5 7C12.7761 7 13 7.22386 13 7.5V13.5C13 13.7761 12.7761 14 12.5 14C12.2239 14 12 13.7761 12 13.5V7.5C12 7.22386 12.2239 7 12.5 7Z"
      />
    </svg>
  )
})

export default Analytics
